import { IEventDispatcher } from '../shared/interfaces/events/event-dispatcher.interface';

export class EventDispatcher<M = any> implements IEventDispatcher<M> {
    private readonly _eventMap: Map<keyof M, Function[]> = new Map();

    /**
     * Listens to the given event.
     */
    public on<E extends keyof M>(event: E, callback: (message: M[E]) => void): IEventDispatcher<M> {
        const callbacks = this._eventMap.get(event);

        if (Array.isArray(callbacks)) {
            callbacks.push(callback);

            return this;
        }

        this._eventMap.set(event, [callback]);

        return this;
    }

    /**
     * Unregisters the given event.
     */
    public off<E extends keyof M>(event: E): IEventDispatcher<M> {
        this._eventMap.delete(event);
        return this;
    }

    /**
     * Dispatches a given event with some given data
     */
    public dispatch<E extends keyof M>(event: E, arg?: M[E]): IEventDispatcher<M> {
        const callbacks = this._eventMap.get(event);

        if (callbacks === undefined) {
            return this;
        }

        for (const callback of callbacks) {
            callback(arg);
        }

        return this;
    }
}
